import React from 'react'
import LeisureActivitiesPageOne from './LeisureActivitiesPageOne'
import LeisureActivitiesPageTwo from './LeisureActivitiesPageTwo'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'

const LeisureActivities = ({ section, trackContent }) => {
  const { allActivities, setAllActivities } = useExercise()
  const { t } = useTranslation('leisure_activities')
  const pageOneTranslations = t('pages.0')
  const pageTwoTranslations = t('pages.1')

  const categories = t('categories', { returnObjects: true })

  const sectionProps = {
    pageOneTranslations,
    pageTwoTranslations,
    categories,
    section,
    allActivities,
    setAllActivities,
    trackContent,
  }

  return (
    <div>
      {section === 0 && <LeisureActivitiesPageOne {...sectionProps} />}
      {section === 1 && <LeisureActivitiesPageTwo {...sectionProps} />}
    </div>
  )
}

export default LeisureActivities
